import { CloseOutlined } from "@ant-design/icons";
import { Modal as AntdModal, type ModalProps as AntdModalProps } from "antd";

import type { AvE2EProps } from "../types";

type ModalProps = AvE2EProps & AntdModalProps;

export function Modal({
  testIdPrefix,
  okButtonProps,
  cancelButtonProps,
  title,
  ...restProps
}: ModalProps) {
  const dataTestId = `${testIdPrefix}-modal`;

  return (
    <AntdModal
      data-testid={dataTestId}
      title={<span data-testid={`${testIdPrefix}-title`}>{title}</span>}
      okButtonProps={{
        ...okButtonProps,
        "data-testid": `${dataTestId}-ok-button`,
      }}
      cancelButtonProps={{
        ...cancelButtonProps,
        "data-testid": `${dataTestId}-cancel-button`,
      }}
      closeIcon={<CloseOutlined data-testid={`${dataTestId}-close-button`} />}
      {...restProps}
    />
  );
}
